import type {Margin} from '@yandex-delivery/blocks'
import React from 'react'

import type {TariffsZone} from '../../../../api'
import {TariffsMap} from '../../../../components/TariffsMap'
import {useMapPoints} from './hooks'
import {marker} from './utils'
import type { Brand } from '@yandex-delivery/shared/types'

type Props = {
  zones: TariffsZone[]
  country: string
  margin?: Margin
  withZoomControls?: boolean
  brand: Brand
}

export function Map({zones, country, margin, withZoomControls, brand}: Props) {
  const points = useMapPoints(zones, country)

  return <TariffsMap brand={brand} margin={margin} marker={marker} points={points} withZoomControls={withZoomControls} />
}
